export class ToggleLowStockUpdateEmailPermissionResponseDTO{
    companyId!: string;
    lowStockEmailEnabled!: boolean;
    
    constructor(data: ToggleLowStockUpdateEmailPermissionResponseDTO){
        Object.assign(this, data);
    }
}